<template>
    <v-container fluid>
        <div class="mb-2">
            <span v-if="hayFiltrosAplicados">
                Filtrando por
            </span>
            <span v-for="(item, index) in filtrosPartes" :key="index">
                <v-chip v-if="filtroActivo(item)" color="info" class="mr-2" outlined small close
                    @click:close="borrarFiltro(index)">
                    {{ item.texto }}
                </v-chip>
            </span>
        </div>
        <fulldialog-parte v-bind:parte="parte" v-bind:contratos="contratos" v-bind:delegaciones="delegaciones"
            v-bind:ambitos="ambitos" v-bind:estadosParte="estadosParte" v-bind:gradosUrgencia="gradosUrgencia"
            v-bind:usuarios="usuarios" v-bind:tecnicos="tecnicos" v-bind:clientes="clientes"
            v-bind:comerciales="comerciales" :headersPartes="headersPartes" v-if="dialog" />
        <div v-if="!dialog">
            <v-card :loading="loading">
                <v-card-title>
                    <v-text-field v-model="buscarPartes" append-icon="mdi-file-search-outline" label="Buscar" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headersPartes" :items="partesFiltrados" :search="buscarPartes" :sort-by="sortBy"
                    :sort-desc="sortDesc" :page="pagActual" :items-per-page="itemsPorPag" @pagination="updatePagination"
                    @update:sort-by="updateSort" @update:sort-desc="updateSortDesc">
                    <template v-slot:item.responsable.name="{ item }">
                        <template v-if="item.responsable !== null">
                            <v-chip outlined>
                                <v-avatar left :color="item.responsable.color">
                                    <span class="white--text">
                                        {{ item.responsable.avatar }}
                                    </span>
                                </v-avatar>
                                {{ item.responsable.name + ' ' + item.responsable.apellidos }}
                            </v-chip>
                        </template>
                    </template>
                    <template v-slot:item.user.name="{ item }">
                        <v-chip outlined>
                            <v-avatar left :color="item.user.color">
                                <span class="white--text">
                                    {{ item.user.avatar }}
                                </span>
                            </v-avatar>
                            {{ item.user.name + ' ' + item.user.apellidos }}
                        </v-chip>
                    </template>
                    <template v-slot:item.fecha="{ item }">
                        {{ formatDate(item.fecha) }}
                    </template>
                    <template v-slot:item.fechaVto="{ item }">
                        {{ formatDate(item.fechaVto) }}
                    </template>
                    <template v-slot:item.estado_parte="{ item }">
                        <v-chip :color="item.estado_parte.color" outlined pill small>
                            {{ item.estado_parte.estado }}
                        </v-chip>
                    </template>
                    <template v-slot:item.acciones="{ item }">
                        <v-icon class="mr-2" @click="editarParte(item)" @keydown.ctrl="ctrlPulsado = true">
                            mdi-file-document-edit-outline
                        </v-icon>
                    </template>
                    <template v-slot:item.horasPonderadas="{ item }">
                        <ProgresoParte 
                            v-if="item.horasEstimadas !== null && item.horasEstimadas!==0"
                            :horasPonderadas="item.horasPonderadas"
                            :horasEstimadas="item.horasEstimadas"
                        />
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <v-dialog v-model="dialogEscogerCliente" persistent max-width="600px">
            <v-card>
                <v-card-title><span class="headline">Cliente</span></v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete :loading="loadingClientes" :disabled="loadingClientes"
                                    v-model="clienteSeleccionado" :items="clientes" chips label="Selecciona"
                                    item-text="name" item-value="name" return-object ref="inputCrear" autofocus
                                    @change="pressEnter()">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogEscogerCliente = false, clienteSeleccionado = {}">Cerrar</v-btn>
                    <v-btn color="blue darken-1" text :disabled="this.$v.clienteSeleccionado.$invalid"
                        @click="nuevoParte(clienteSeleccionado)" @keydown.ctrl="ctrlPulsado = true" ref="anadir">
                        Añadir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSolicitarDesbloqueo" persistent max-width="580">
            <v-card>
                <v-card-title class="headline">Parte en uso</v-card-title>
                <v-card-text v-if="dialogSolicitarDesbloqueo">
                    {{ bloqueadoUsuario }} tiene este parte abierto
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="dialogSolicitarDesbloqueo = false; quitarURLParams()">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="sololecturaParte()">
                        Solo lectura
                    </v-btn>
                    <v-btn color="success" text @click="solicitarControl()">
                        Solicitar control
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEsperaRespuesta" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Esperando respuesta de {{ bloqueadoUsuario }}</v-card-title>
                <v-card-text>
                    <v-alert dense outlined border="left" type="warning" icon="mdi-alert-outline" v-if="timeoutRespuesta">
                        No se obtuvo ninguna respuesta. Se ha forzado el desbloqueo del parte.
                    </v-alert>
                    <v-alert dense outlined border="left" type="success" icon="mdi-check-circle-outline"
                        v-if="parteDesbloqueado && !timeoutRespuesta">
                        {{ bloqueadoUsuario }} ha aceptado la solicitud. Parte desbloqueado.
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="cerrarDialogEsperaRespuesta(); quitarURLParams()">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="editarParte(parte); cerrarDialogEsperaRespuesta()"
                        @keydown.ctrl="ctrlPulsado = true" color="success" :disabled="!parteDesbloqueado">
                        <v-progress-circular :value="countdown" size="18" rotate="270" color="info" class="mx-1"
                            v-if="mostrarCountdown"></v-progress-circular>
                        Abrir parte
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-speed-dial v-model="fab" fixed direction="top" transition="slide-y-reverse-transition"
            style="bottom: 37px; right: 30px;">
            <template v-slot:activator>
                <v-btn v-model="fab" color="teal lighten-1" dark fab>
                    <v-icon v-if="fab">mdi-close</v-icon>
                    <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
            </template>

            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab dark small color="green" @click="seleccionarCliente()"
                        @keydown.ctrl="ctrlPulsado = true">
                        <v-icon>mdi-file-document-outline</v-icon>
                    </v-btn>
                </template>
                <span>Crear parte</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab dark small color="blue" @click="abrirDialogFiltros()">
                        <v-icon>mdi-filter-outline</v-icon>
                    </v-btn>
                </template>
                <span>Filtrar partes</span>
            </v-tooltip>
        </v-speed-dial>
        <v-dialog v-model="dialogFiltros" persistent max-width="700">
            <v-card>
                <v-card-title class="headline">Filtros</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-autocomplete :loading="loadingClientes" :disabled="loadingClientes"
                                v-model="filtrosPartesVentanaFiltros.clienteSeleccionadoFiltro.filtro" :items="clientes"
                                chips label="Cliente" item-text="name" item-value="code" clearable ref="inputFiltrar"
                                autofocus>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-autocomplete v-model="filtrosPartesVentanaFiltros.idsEstadosParteSeleccionados.filtro"
                                :items="estadosParte" item-text="estado" item-value="id" chips label="Estado" multiple>
                                <template v-slot:selection="data">
                                    <v-chip :color="data.item.color" outlined small close @click:close="remove(data.item)">
                                        {{ data.item.estado }}
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="Núm. Parte" v-model="filtrosPartesVentanaFiltros.numParte.filtro"
                                clearable></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-autocomplete v-model="filtrosPartesVentanaFiltros.responsableSeleccionado.filtro"
                                :items="tecnicos" chips label="Responsable de cuenta" item-text="name" item-value="id">
                                <template v-slot:selection="data">
                                    <v-chip v-bind="data.attrs" :input-value="data.selected" close
                                        @click:close="removeResponsable(data.item)">
                                        <v-avatar left :color="data.item.color">
                                            <span class="white--text">{{
                                                data.item.avatar
                                            }}</span>
                                        </v-avatar>
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-avatar :color="data.item.color">
                                            <span class="white--text">{{
                                                data.item.avatar
                                            }}</span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                data.item.name
                                            }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                data.item.apellidos
                                            }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-autocomplete v-model="filtrosPartesVentanaFiltros.idsTecnicosSeleccionados.filtro"
                                :items="tecnicos" chips label="Técnico asignado" item-text="name" item-value="id" multiple>
                                <template v-slot:selection="data">
                                    <v-chip v-bind="data.attrs" :input-value="data.selected" close
                                        @click:close="removeTecnico(data.item)">
                                        <v-avatar left :color="data.item.color">
                                            <span class="white--text">{{
                                                data.item.avatar
                                            }}</span>
                                        </v-avatar>
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-avatar :color="data.item.color">
                                            <span class="white--text">{{
                                                data.item.avatar
                                            }}</span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                data.item.name
                                            }}</v-list-item-title>
                                            <v-list-item-subtitle>{{
                                                data.item.apellidos
                                            }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <date-picker v-bind:date="filtrosPartesVentanaFiltros.fechaVto.filtro" v-bind:title="fechaTitle"
                                @actualizarFecha="actualizarFecha"></date-picker>
                        </v-col>
                    </v-row>
                    <v-card outlined>
                        <v-card-subtitle>Filtro fecha de inicio del parte</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <date-picker v-bind:date="filtrosPartesVentanaFiltros.fechaParte.inicio"
                                        v-bind:title="'Inicio'" @actualizarFecha="actualizarFechaInicio"></date-picker>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <date-picker v-bind:date="filtrosPartesVentanaFiltros.fechaParte.fin"
                                        v-bind:title="'Fin'" @actualizarFecha="actualizarFechaFin"></date-picker>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogFiltros = false">Cancelar</v-btn>
                    <v-btn color="success" text @click="filtrarPartes()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import formatearFecha from '@/mixins/formatearFecha';
import formatDate from '@/mixins/formatearFecha';
import parseDate from '@/mixins/formatearFecha';
import getArrayPositionByItemId from '@/mixins/getArrayPositionByItemId';
import FullDialogParte from './FullDialogParte';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
import Echo from 'laravel-echo';
// import io from 'socket.io-client';
import Datepicker from "@/components/utils/Datepicker";
import ProgresoParte from "./ProgresoParte";
export default {
    name: 'Partes',
    mixins: [formatearFecha, formatDate, parseDate, getArrayPositionByItemId],
    data: () => ({
        fab: false,
        loading: false,
        loadingClientes: false,
        dialogEscogerCliente: false,
        dialogSolicitarDesbloqueo: false,
        dialogEsperaRespuesta: false,
        dialogFiltros: false,
        bloqueadoUsuario: null,
        countdown: 100,
        mostrarCountdown: false,
        intervalCountdownAnimation: null,
        intervalCountdown: null,
        timeoutRespuesta: false,
        parteDesbloqueado: false,
        clienteSeleccionado: {},
        headersPartes: [
            {
                text: 'Núm. Parte',
                align: 'start',
                filterable: true,
                sortable: true,
                value: 'numParte'
            },
            {
                text: 'Núm. Pedido',
                align: 'start',
                filterable: true,
                sortable: true,
                value: 'numPedido'
            },
            {
                text: 'Cliente',
                filterable: true,
                sortable: true,
                value: 'cliente',
            },
            {
                text: "Concepto",
                filterable: true,
                sortable: true,
                value: "concepto",
            },
            {
                text: 'Responsable',
                filterable: true,
                sortable: true,
                value: 'responsable.name'
            },
            {
                text: 'Técnico',
                filterable: true,
                sortable: true,
                value: 'user.name'
            },
            {
                text: 'Inicio',
                filterable: true,
                sortable: true,
                value: 'fecha'
            },
            {
                text: 'Fecha vto.',
                filterable: true,
                sortable: true,
                value: 'fechaVto'
            },
            {
                text: 'Estado',
                filterable: true,
                sortable: true,
                value: 'estado_parte'
            },
            {
                text: '% horas',
                filterable: false,
                sortable: true,
                value: 'horasPonderadas'
            },
            {
                text: '',
                filterable: false,
                sortable: false,
                value: 'acciones'
            }
        ],
        buscarPartes: '',
        partes: [],
        // parte:[],
        estadosParte: [],
        usuarios: [],
        tecnicos: [],
        comeciales: [],
        clientes: [],
        ctrlPulsado: false,
        fechaTitle: 'Fecha vencimiento',
        filtrosPartes: {
            clienteSeleccionadoFiltro: {
                texto: 'Cliente',
                filtro: null
            },
            idsEstadosParteSeleccionados: {
                texto: 'Estado del parte',
                filtro: [6, 1, 2] //1-> Partes activos 2-> Pdte. Fidelizar, 6 -> Estado previo a activo
            },
            numParte: {
                texto: 'Número de parte',
                filtro: null
            },
            idsTecnicosSeleccionados: {
                texto: 'Técnico',
                filtro: []
            },
            responsableSeleccionado: {
                texto: 'Responsable',
                filtro: null
            },
            fechaVto: {
                texto: 'Fecha de vencimiento',
                filtro: null
            },
            fechaParte: {
                texto: 'Fecha parte',
                inicio: null,
                fin: null
            }
        },
        filtrosPartesVentanaFiltros: {
            clienteSeleccionadoFiltro: {
                filtro: null
            },
            idsEstadosParteSeleccionados: {
                filtro: null
            },
            responsableSeleccionado: {
                filtro: null
            },
            numParte: {
                filtro: null
            },
            idsTecnicosSeleccionados: {
                filtro: null
            },
            fechaVto: {
                filtro: null
            },
            fechaParte: {
                inicio: null,
                fin: null
            }
        },
        pagActual: 1,
        itemsPorPag: 10,
        sortBy: 'fecha',
        sortDesc: true

    }),
    validations: {
        clienteSeleccionado: { required }
    },
    methods: {
        ...mapActions('partes', ['setDialog']),
        ...mapActions(['setLoading', 'setSnackbar']),
        updateSort(event) {
            this.sortBy = event
        },
        updateSortDesc(event) {
            this.sortDesc = event
        },
        updatePagination(pagination) {
            console.log(pagination);
            this.itemsPorPag = pagination.itemsPerPage;
            this.pagActual = pagination.page;
        },
        async editarParte(parte) {
            // Si por URL no se envía el id del parte
            if (!this.$route.params.id) {
                this.$router.push({ name: 'parte', params: { id: parte.id } });
            }
            this.setLoading(true);
            try {
                let respuestaPartes = await axios.get(`/api/partes/${parte.id}`);
                console.log(respuestaPartes.data);
                this.$store.dispatch('acciones/setParte', {
                    parte: respuestaPartes.data
                });
                // this.parte = respuestaPartes.data;
                console.log(this.parte);
                // console.log("--------");
                // console.log(this.parte.updated_at);
                // console.log("--------");
                await this.getDatosParte(this.parte);
                this.parte.fechaFormateada = this.formatDate(new Date(this.parte.fecha).toISOString().substr(0, 10));
                this.parte.fechaVtoFormateada = this.parte.fechaVto ? this.formatDate(new Date(this.parte.fechaVto).toISOString().substr(0, 10)) : null
                this.parte.accionesEliminadas = [];
                this.parte.accionesModificadas = [];
                this.parte.fidelizacionesEliminadas = [];
                this.parte.fidelizacionesModificadas = [];
                this.setLoading(false);
                if (this.parte.bloqueado) {
                    this.dialogSolicitarDesbloqueo = true;
                    this.bloqueadoUsuario = this.usuarios[this.getArrayPositionByItemId(this.usuarios, this.parte.bloqueado_usuario)].name;
                } else {
                    this.setDialog(true);
                }
            } catch (error) {
                console.log(error);
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido abrir el parte'
                });
            }
        },
        sololecturaParte() {
            this.dialogSolicitarDesbloqueo = false;
            this.setDialog(true);
        },
        async solicitarControl() {
            this.setLoading(true);
            try {
                await axios.get(`/api/solicitarparte/${this.parte.id}`);
                this.dialogSolicitarDesbloqueo = false;
                // window.io = io;
                // window.Echo = new Echo({
                //     broadcaster: 'socket.io',
                //     host: process.env.VUE_APP_SOCKET_IO
                // });
                // window.Echo.channel("ardipartes_database_channel-partes").listen("RespuestaSolicitarParte", (data) => {
                //     console.log('Respuesta solicitud');
                //     console.log(data);
                //     if (parseInt(data.id) === this.parte.id) {
                //         if (parseInt(data.respuesta) === 1) {
                //             console.log("Ha aceptado");
                //             // Habilitar botón abrir parte
                //             this.detenerCountdown();
                //             this.parteDesbloqueado = true;
                //         } else {
                //             console.log("Ha rechazado la petición");
                //             // Cerrar y mostrar aviso de que ha rechazado la petición
                //             this.cerrarDialogEsperaRespuesta();
                //             this.detenerCountdown();
                //             this.setSnackbar({
                //                 tipo: 'info',
                //                 mensaje: this.bloqueadoUsuario + ' ha rechazado la petición. Inténtalo de nuevo más tarde o abre el parte en solo lectura'
                //             });
                //         }
                //     }

                // });
                this.dialogEsperaRespuesta = true;
                this.iniciarCountdown();
            } catch (error) {
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido realizar la petición'
                });
            }
            this.setLoading(false);
        },
        cerrarDialogEsperaRespuesta() {
            this.detenerCountdown();
            // window.Echo.leave("ardipartes_database_channel-partes");
            this.timeoutRespuesta = false;
            this.parteDesbloqueado = false;
            this.dialogEsperaRespuesta = false;
        },
        iniciarCountdown() {
            this.mostrarCountdown = true;
            // Countdown de 25 segundos
            this.intervalCountdownAnimation = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown -= 6.6;
                }
            }, 1000);
            this.intervalCountdown = setTimeout(() => {
                this.detenerCountdown();
                this.timeoutRespuesta = true;
                this.desbloquearParte();
            }, 15000);
        },
        detenerCountdown() {
            clearInterval(this.intervalCountdownAnimation);
            clearInterval(this.intervalCountdown);
            this.countdown = 100;
            this.mostrarCountdown = false;
        },
        async desbloquearParte() {
            try {
                await axios.patch(`/api/partes/${this.parte.id}`);
                this.parteDesbloqueado = true;
            } catch (error) {
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido desbloquear el parte, ponte en contacto con el administrador de la aplicación'
                });
            }
        },
        async seleccionarCliente() {
            this.dialogEscogerCliente = true;
            if (this.ctrlPulsado) {
                this.loadingClientes = true;
                try {
                    this.setSnackbar({
                        tipo: 'info',
                        mensaje: 'Caché de clientes vaciada'
                    });
                    let respuestaClientes = await axios.get('/api/clientes?cache=0');
                    this.clientes = respuestaClientes.data;
                    this.ejecutarFoco('inputCrear');
                } catch (error) {
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido recuperar los clientes'
                    });
                }
                this.ctrlPulsado = false;
                this.loadingClientes = false;
            }
            // else{
            //     axios.get('/api/clientes').then(respuesta => {
            //         this.loadingClientes = false;
            //         this.clientes = respuesta.data;
            //         this.ejecutarFoco('inputCrear');
            //     }).catch(error => {
            //         this.loadingClientes = false;
            //         this.setSnackbar({
            //             tipo: 'error',
            //             mensaje: 'Error. No se han podido recuperar los clientes'
            //         });
            //     });
            // }
        },
        ejecutarFoco(input) {
            this.$nextTick(() => {
                this.$refs[input].focus();
            });
        },
        async nuevoParte(clienteSeleccionado) {
            this.setLoading(true);
            let idComercialReferencia = null;
            let comercialReferencia = this.comerciales.filter(item => item.email === clienteSeleccionado.comercialEmail);
            // Verificamos si el comercial está informado y existe en la aplicación de partes
            if (comercialReferencia.length > 0) {
                idComercialReferencia = comercialReferencia[0].id;
            }
            this.clienteSeleccionado = {};
            this.dialogEscogerCliente = false;
            // TODO consultar info del cliente seleccionado (contratos, delegaciones, etc.) y enviarsela como prop al componente hijo (fullDialog)
            let parte = {
                numParte: null,
                cliente_id: clienteSeleccionado.code,
                cliente: clienteSeleccionado.name,
                realizar: '',
                fecha: new Date().toISOString().substr(0, 10),
                fechaFormateada: this.formatDate(new Date().toISOString().substr(0, 10)),
                inicio: new Date().toLocaleTimeString('es-ES', {
                    hour12: false,
                    hour: '2-digit',
                    minute: '2-digit'
                }),
                fechaVto: null,
                fechaVtoFormateada: null,
                urlTrello: '',
                delegacion_id: '',
                horasEstimadas: null,
                acciones: [],
                fidelizaciones: [],
                registros_comunicaciones: [],
                fidelizar: 0,
                estadoParte_id: 1,
                bloqueado: false,
                user_id: 6, //id usuario general
                responsable_id: null,
                comercial_id: idComercialReferencia,
                esEditable: true
            };
            this.$store.dispatch('acciones/setParte', {
                parte
            });
            try {
                await this.getDatosParte(this.parte);
                this.setLoading(false);
                if (this.delegaciones.length > 0) {
                    this.setDialog(true);
                } else {
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. Este cliente no tiene delegaciones informadas en BC'
                    });
                }
            } catch (error) {
                console.log(error);
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos necesarios para generar el parte'
                });
            }
        },
        async getDatosParte(parte) {
            try {
                if (this.ctrlPulsado) {
                    // Si el usuario está pulsando el ctrl al clicar, borramos caché de los contratos de este cliente
                    this.setSnackbar({
                        tipo: 'info',
                        mensaje: 'Caché vaciada para los datos de este cliente'
                    });
                    let respuestaContratos = await axios.get(`/api/contratos?codCliente=${parte.cliente_id}&parteId=${parte.id}&cache=0`);
                    this.contratos = respuestaContratos.data;

                    let respuestaDelegaciones = await axios.get(`/api/delegaciones?codCliente=${parte.cliente_id}&cache=0`);
                    this.delegaciones = respuestaDelegaciones.data;

                    this.ctrlPulsado = false;
                } else {
                    let respuestaContratos = await axios.get(`/api/contratos?codCliente=${parte.cliente_id}&parteId=${parte.id}`);
                    this.contratos = respuestaContratos.data;

                    let respuestaDelegaciones = await axios.get(`/api/delegaciones?codCliente=${parte.cliente_id}`);
                    this.delegaciones = respuestaDelegaciones.data;

                }
                if(parte.responsable_id === null){
                    try{
                        let respuestaResponsable = await axios.get(`/api/tecnicosCliente?cliente_id=${parte.cliente_id}`);
                        parte.responsable_id = (this.tecnicos.find(tecnico => tecnico.email === respuestaResponsable.data[0].responsableCuenta))?.id;
                    }catch(error){
                        this.setSnackbar({
                            tipo: 'info',
                            mensaje: 'No se ha podido recuperar el responsable de cuenta de dynamics. Es posible que el cliente no exista en dynamics o no tenga informado el responsable.'
                        });
                    }
                }
                if (parte.delegacion_id === '' && this.delegaciones.length > 0) {
                    this.parte.delegacion_id = this.delegaciones[0].delegacionId;
                }

                let cliente = this.clientes.find(c => c.code === parte.cliente_id);
                if (cliente) {
                    this.parte.obsCliente = cliente.observaciones;
                }

                let cliConObs = this.clientes.filter(c => c.observaciones !== '');
                console.log(cliConObs);
                // console.log('*************************');
                // console.log(parte);
                // console.log('*************************');
            } catch (error) {
                console.log(error);
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos necesarios para generar el parte'
                });
            }
        },
        async abrirDialogFiltros() {
            // Hacemos una copia del objeto en uno temporal de la ventan para evitar que se apliquen los cambios sin aceptarlos
            this.filtrosPartesVentanaFiltros = JSON.parse(JSON.stringify(this.filtrosPartes));
            this.loadingClientes = true;
            this.dialogFiltros = true;
            try {
                let respuestaClientes = await axios.get('/api/clientes');
                this.clientes = respuestaClientes.data;
            } catch (error) {
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los clientes'
                });
            }
            this.loadingClientes = false;
            this.ejecutarFoco('inputFiltrar');
        },
        remove(item) {
            let posicion = this.filtrosPartesVentanaFiltros.idsEstadosParteSeleccionados.filtro.indexOf(item.id);
            if (posicion >= 0) this.filtrosPartesVentanaFiltros.idsEstadosParteSeleccionados.filtro.splice(posicion, 1);
        },
        removeTecnico(item) {
            let posicion = this.filtrosPartesVentanaFiltros.idsTecnicosSeleccionados.filtro.indexOf(item.id);
            if (posicion >= 0) this.filtrosPartesVentanaFiltros.idsTecnicosSeleccionados.filtro.splice(posicion, 1);
        },
        removeResponsable(item) {
            this.filtrosPartesVentanaFiltros.responsableSeleccionado.filtro = null
        },
        actualizarFecha(val) {
            this.filtrosPartesVentanaFiltros.fechaVto.filtro = val;
        },
        actualizarFechaInicio(val) {
            this.filtrosPartesVentanaFiltros.fechaParte.inicio = val;
        },
        actualizarFechaFin(val) {
            this.filtrosPartesVentanaFiltros.fechaParte.fin = val;
        },
        async filtrarPartes() {
            console.log(this.filtrosPartesVentanaFiltros);
            this.filtrosPartes = JSON.parse(JSON.stringify(this.filtrosPartesVentanaFiltros));
            this.setLoading(true);
            let params = {
                cliente: this.filtrosPartes.clienteSeleccionadoFiltro.filtro,
                idsEstadosParteSeleccionados: this.filtrosPartes.idsEstadosParteSeleccionados.filtro,
                numParte: this.filtrosPartes.numParte.filtro,
                idsTecnicosSeleccionados: this.filtrosPartes.idsTecnicosSeleccionados.filtro,
                responsableSeleccionado: this.filtrosPartes.responsableSeleccionado.filtro,
                fechaVto: this.filtrosPartes.fechaVto.filtro,
                fechaInicio: this.filtrosPartes.fechaParte.inicio,
                fechaFin: this.filtrosPartes.fechaParte.fin
            }
            try {
                let respuesta = await axios.get('/api/partes', { params });
                this.partes = respuesta.data;
                this.setLoading(false);
                this.dialogFiltros = false;
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los partes'
                });
            }
        },
        borrarFiltro(clave) {
            // Hacemos una copia del objeto en uno temporal de la ventan para evitar que se apliquen los cambios sin aceptarlos
            this.filtrosPartesVentanaFiltros = JSON.parse(JSON.stringify(this.filtrosPartes));
            if (clave === 'fechaParte') {
                this.filtrosPartesVentanaFiltros[clave].inicio = null;
                this.filtrosPartesVentanaFiltros[clave].fin = null;
            } else {
                this.filtrosPartesVentanaFiltros[clave].filtro = null;
            }
            this.filtrarPartes();

        },
        filtroActivo(item) {
            if (item.inicio !== undefined && item.inicio !== null && item.fin !== undefined && item.fin !== null) {
                return true;
            }
            if (Array.isArray(item.filtro) && item.filtro.length > 0 || !Array.isArray(item.filtro) && item.filtro !== null && item.filtro !== undefined) {
                return true;
            }
            return false;
        },
        quitarURLParams() {
            if (this.$route.params.id) {
                this.$router.push({ name: 'partes' });
            }
        },
        async cargarPartes() {
            let pagActual = this.pagActual;
            let itemsPorPagina = this.itemsPorPag;
            let sort = { 'by': this.sortBy, 'desc': this.sortDesc }
            let params = {
                cliente: this.filtrosPartes.clienteSeleccionadoFiltro.filtro,
                idsEstadosParteSeleccionados: this.filtrosPartes.idsEstadosParteSeleccionados.filtro,
                numParte: this.filtrosPartes.numParte.filtro,
                idsTecnicosSeleccionados: this.filtrosPartes.idsTecnicosSeleccionados.filtro,
                responsableSeleccionado: this.filtrosPartes.responsableSeleccionado.filtro,
                fechaVto: this.filtrosPartes.fechaVto.filtro
            }
            let respuestaPartes = await axios.get("/api/partes", { params });
            this.partes = respuestaPartes.data;
            this.pagActual = pagActual;
            this.itemsPorPag = itemsPorPagina;
            this.sortBy = sort['by']
            this.sortDesc = sort['desc']
        },
        handleKeys() { //--------------------------------------------------- no va
            if (event.keyCode === 78 && event.ctrlKey) { //Si se pulsa ctrl+N 
                event.preventDefault(); // cancelamos la accion por defecto del navegador
                this.seleccionarCliente(); // Abrimos la ventana de creación de partes
            }
        },
        pressEnter() {
            if (this.dialogEscogerCliente == true) {
                // this.nuevoParte(clienteSeleccionado);
                this.$nextTick(() => {
                    this.$refs.anadir.$el.focus();
                });
            }
        }
    },
    async mounted() {
        this.loading = true;
        try {
            let respuestaUsuarios = await axios.get('/api/usuarios'); //LISTAR TODOS LOS USUARIOS
            this.usuarios = respuestaUsuarios.data;

            let respuestaEstadosParte = await axios.get('/api/estadospartes');
            this.estadosParte = respuestaEstadosParte.data;

            let respuestaComerciales = await axios.get("/api/usuarios?grupo=3");
            this.comerciales = respuestaComerciales.data;

            let respuestaAmbitos = await axios.get("/api/ambitos");
            this.ambitos = respuestaAmbitos.data;

            let respuestaGradosurgencia = await axios.get("/api/gradosurgencia");
            this.gradosUrgencia = respuestaGradosurgencia.data;

            let respuestaTecnicos = await axios.get("/api/usuarios?grupo=2");
            this.tecnicos = respuestaTecnicos.data;

            let respuestaClientes = await axios.get('/api/clientes');
            this.clientes = respuestaClientes.data;

            // Si por URL se envía el id del parte abrir dialog del parte para mostrar la información de ese parte
            if (this.$route.params.id) {
                let parte = {
                    id: this.$route.params.id
                }
                this.editarParte(parte);
            }

            this.cargarPartes();

            this.loading = false;
            window.addEventListener('keydown', this.handleKeys);
        } catch (error) {
            this.loading = false;
            console.log(error);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se han podido recuperar los datos de los partes'
            });
        }
        // // websocket listado partes
        // window.io = io;
        // window.Echo = new Echo({
        //     broadcaster: "socket.io",
        //     host: process.env.VUE_APP_SOCKET_IO,
        // });
        // window.Echo.channel("ardipartes_database_channel-partes").listen("ActualizarListadoPartes", (data) => {
        //     if (data.accion === 'delete') {
        //         let posicionArray = this.getArrayPositionByItemId(this.partes, data.parte);
        //         this.partes.splice(posicionArray, 1);
        //     } else {
        //         if (this.partes.find(parte => parte.id === data.parte.id) === undefined) {
        //             this.partes.push(data.parte)
        //         } else {
        //             this.partes = this.partes.map(parte => {
        //                 if (parte.id === data.parte.id) {
        //                     parte = data.parte
        //                 }
        //                 return parte
        //             })
        //         }
        //     }
        //     // this.filtrosPartesVentanaFiltros = JSON.parse(JSON.stringify(this.filtrosPartes));
        //     // this.filtrarPartes();
        // });
    },
    destroyed() {
        console.log("destroyed partes");
        window.removeEventListener('keydown', this.handleKeys);
        // window.Echo.leave("ardipartes_database_channel-partes");
    },
    computed: {
        ...mapState('partes', ['dialog']),
        hayFiltrosAplicados() {
            // Si al menos hay 1 filtro activo devuelve true, de lo contrario, devuelve false
            let claves = Object.keys(this.filtrosPartes);
            // He tenido que cambiar el foreach por un for porque en el foreach no se detiene la ejecución al hacer un return --> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#description
            for (let i = 0; i < claves.length; i++) {
                if (this.filtroActivo(this.filtrosPartes[claves[i]])) return true;
            }
            return false;
        },
        parte: {
            get() {
                return this.$store.getters["acciones/parte"]
            },
            set(newValue) {
                return this.$store.dispatch("acciones/setParte", newValue)
            }
        },
        partesFiltrados() {
            let parteFiltrado = JSON.parse(JSON.stringify(this.partes))
            // Tipo parte
            if (this.filtrosPartes.idsEstadosParteSeleccionados.filtro && this.filtrosPartes.idsEstadosParteSeleccionados.filtro.length) {
                parteFiltrado = parteFiltrado.filter(parte => this.filtrosPartes.idsEstadosParteSeleccionados.filtro.includes(parte.estadoParte_id));
            }
            // Cliente
            if (this.filtrosPartes.clienteSeleccionadoFiltro.filtro) {
                parteFiltrado = parteFiltrado.filter(parte => this.filtrosPartes.clienteSeleccionadoFiltro.filtro === parte.cliente_id);
            }
            // Tecnico asignado
            if (this.filtrosPartes.idsTecnicosSeleccionados.filtro && this.filtrosPartes.idsTecnicosSeleccionados.filtro.length) {
                parteFiltrado = parteFiltrado.filter(parte => this.filtrosPartes.idsTecnicosSeleccionados.filtro.includes(parte.user_id))
            }
            // responsable asignado
            if (this.filtrosPartes.responsableSeleccionado.filtro) {
                parteFiltrado = parteFiltrado.filter(parte => this.filtrosPartes.responsableSeleccionado.filtro === parte.responsable_id)
            }
            // Fecha vencimiento
            if (this.filtrosPartes.fechaVto.filtro) {
                parteFiltrado = parteFiltrado.filter(parte => this.filtrosPartes.fechaVto.filtro === parte.fechaVto);
            }
            return parteFiltrado;
        }

    },
    watch: {
        dialog() {
            // Hemos quitado esto después de implementar la carga de parte por websockets
            // Al cerrar el full dialog recargamos los partes abiertos para actualizar los posibles cambios
            // if(!this.dialog){
            //     this.loading = true;
            //     this.cargarPartes();
            //     this.loading = false;
            // }
        }
    },
    components: {
        'fulldialog-parte': FullDialogParte,
        'date-picker': Datepicker,
        ProgresoParte
    }
}
</script>